'use client';

import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import { format, parseISO } from 'date-fns';
import { MeSnapshot } from '../../state/MeSnapshot';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Filler
);

interface MeSnapshotTrendChartProps {
    snapshots: MeSnapshot[];
    ratingType: 'whoAmI' | 'myMission';
}

export default function MeSnapshotTrendChart({ snapshots, ratingType }: MeSnapshotTrendChartProps) {
    if (!snapshots || snapshots.length === 0) {
        return null;
    }

    // Сортируем по дате
    const sortedSnapshots = [...snapshots].sort((a, b) => 
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );

    const labels = sortedSnapshots.map(s => format(parseISO(s.date), 'dd.MM'));
    const ratingData = sortedSnapshots.map(s => ratingType === 'whoAmI' ? s.whoAmIRating : s.myMissionRating);

    const isWhoAmI = ratingType === 'whoAmI';
    const color = isWhoAmI ? '#667eea' : '#d7a358';
    const label = isWhoAmI ? 'Кто я' : 'Моя миссия';

    const data = {
        labels,
        datasets: [
            {
                label,
                data: ratingData,
                borderColor: color,
                backgroundColor: isWhoAmI 
                    ? 'rgba(102, 126, 234, 0.1)' 
                    : 'rgba(215, 163, 88, 0.1)',
                tension: 0.3,
                fill: true,
                pointRadius: 4,
                pointHoverRadius: 6,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (context: any) => {
                        const value = context.parsed.y;
                        return `${label}: ${value}/10`;
                    }
                }
            }
        },
        scales: {
            y: {
                min: 0,
                max: 10,
                ticks: {
                    stepSize: 1,
                },
            },
        },
    };

    return (
        <div style={{ height: '250px' }}>
            <Line data={data} options={options} />
        </div>
    );
}
